import { MultiAccountCodeAmount } from "./business.model";

export type FinancialInstCode =
  | "001"
  | "002"
  | "003"
  | "004"
  | "007"
  | "008"
  | "011"
  | "012"
  | "020"
  | "023"
  | "027"
  | "031"
  | "032"
  | "034"
  | "035"
  | "037"
  | "039"
  | "045"
  | "048"
  | "050"
  | "051"
  | "052"
  | "054"
  | "055"
  | "057"
  | "058"
  | "059"
  | "060"
  | "061"
  | "062"
  | "063"
  | "064"
  | "066"
  | "067"
  | "071"
  | "076"
  | "077"
  | "079"
  | "081"
  | "088"
  | "089"
  | "090"
  | "091"
  | "092"
  | "093"
  | "094"
  | "095"
  | "096"
  | "097"
  | "098"
  | "099"
  | "101"
  | "102"
  | "103"
  | "104"
  | "105"
  | "106"
  | "209"
  | "218"
  | "221"
  | "222"
  | "223"
  | "224"
  | "225"
  | "227"
  | "238"
  | "240"
  | "243"
  | "247"
  | "261"
  | "262"
  | "263"
  | "264"
  | "265"
  | "266"
  | "267"
  | "269"
  | "270"
  | "271"
  | "278"
  | "279"
  | "280"
  | "287"
  | "288"
  | "290"
  | "291"
  | "292"
  | "293"
  | "294"
  | "299"
  | "361"
  | "364"
  | "365"
  | "366"
  | "367"
  | "368"
  | "369"
  | "370"
  | "371"
  | "372"
  | "373"
  | "374"
  | "381"
  | "431"
  | "432"
  | "433"
  | "434"
  | "435"
  | "436"
  | "437"
  | "438"
  | "439"
  | "440"
  | "441"
  | "442"
  | "443"
  | "444"
  | "445"
  | "446"
  | "447"
  | "448"
  | "449"
  | "450"
  | "452"
  | "453"
  | "454"
  | "455"
  | "456"
  | "457"
  | "458";

export const FI_CODE: { [key in FinancialInstCode]: string } = {
  "001": "한국은행",
  "002": "산업은행",
  "003": "기업은행",
  "004": "국민은행",
  "007": "수협은행",
  "008": "수출입은행",
  "011": "농협은행",
  "012": "지역농축협",
  "020": "우리은행",
  "023": "SC제일은행",
  "027": "한국씨티은행",
  "031": "대구은행",
  "032": "부산은행",
  "034": "광주은행",
  "035": "제주은행",
  "037": "전북은행",
  "039": "경남은행",
  "045": "새마을금고중앙회",
  "048": "신협",
  "050": "저축은행",
  "051": "외국은행",
  "052": "모건스탠리은행",
  "054": "HSBC",
  "055": "도이치은행",
  "057": "제이피모건체이스은행",
  "058": "미즈호은행",
  "059": "엠유에프지은행",
  "060": "BOA",
  "061": "비엔피파리바은행",
  "062": "중국공상은행",
  "063": "중국은행",
  "064": "산림조합중앙회",
  "066": "교통은행",
  "067": "중국건설은행",
  "071": "우체국",
  "076": "신용보증기금",
  "077": "기술보증기금",
  "079": "우체국은행", // BE 대응 임시 추가
  "081": "하나은행",
  "088": "신한은행",
  "089": "케이뱅크",
  "090": "카카오뱅크",
  "091": "국세청",
  "092": "토스뱅크",
  "093": "화재보험회사",
  "094": "캐피털사",
  "095": "경찰청",
  "096": "한국신용정보(주)",
  "097": "효성",
  "098": "청호",
  "099": "금융결제원",
  "101": "한국신용정보원",
  "102": "대신저축은행",
  "103": "에스비아이저축은행",
  "104": "에이치케이저축은행",
  "105": "웰컴저축은행",
  "106": "신한저축은행",
  "209": "유안타증권",
  "218": "KB증권",
  "221": "상상인증권",
  "222": "한양증권",
  "223": "리딩투자증권",
  "224": "BNK투자증권",
  "225": "IBK투자증권",
  "227": "케이티비투자증권",
  "238": "미래에셋증권",
  "240": "삼성증권",
  "243": "한국투자증권",
  "247": "NH투자증권",
  "261": "교보증권",
  "262": "하이투자증권",
  "263": "현대차증권",
  "264": "키움증권",
  "265": "이베스트투자증권",
  "266": "SK증권",
  "267": "대신증권",
  "269": "한화투자증권",
  "270": "하나금융투자",
  "271": "토스증권",
  "278": "신한금융투자",
  "279": "DB금융투자",
  "280": "유진투자증권",
  "287": "메리츠증권주식회사",
  "288": "카카오페이증권",
  "290": "부국증권",
  "291": "신영증권",
  "292": "케이프투자증권",
  "293": "한국증권금융",
  "294": "한국포스증권",
  "299": "아주캐피탈",
  "361": "BC카드",
  "364": "광주카드",
  "365": "삼성카드",
  "366": "신한카드",
  "367": "현대카드",
  "368": "롯데카드",
  "369": "수협카드",
  "370": "씨티카드",
  "371": "NH카드",
  "372": "전북카드",
  "373": "제주카드",
  "374": "하나카드",
  "381": "KB국민카드",
  "431": "미래에셋생명",
  "432": "한화생명",
  "433": "교보라이프플래닛생명",
  "434": "현대라이프생명",
  "435": "라이나생명",
  "436": "교보생명",
  "437": "에이비엘생명",
  "438": "신한생명",
  "439": "KB생명보험",
  "440": "농협생명",
  "441": "삼성화재",
  "442": "현대해상",
  "443": "동부화재",
  "444": "KB손해보험",
  "445": "롯데손해보험",
  "446": "오렌지라이프생명보험",
  "447": "악사손해보험",
  "448": "메리츠화재",
  "449": "농협손해보험",
  "450": "푸르덴셜생명보험",
  "452": "삼성생명",
  "453": "흥국생명",
  "454": "한화생명보험",
  "455": "AIA생명보험",
  "456": "DGB생명보험",
  "457": "DB생명보험",
  "458": "KDB생명보험",
} as const;

export interface BankStatement {
  accNo: string;
  accType: "DEMAND" | "SAVINGS" | null; // 계좌 유형 (요구불계좌, 적금계좌, 유형없음)
  accountCode: string | null;
  multiAccountCodes?: MultiAccountCodeAmount[] | null; // 다중 계정 코드와 금액
  balance: number; // 잔액
  bankCd: FinancialInstCode; // 은행 코드
  curCd: string | null; // 통화 코드 (외화이체 선택시 입력값)
  id: string;
  inAmt: number;
  isAccountingConfirmed: boolean | null; // 회계 분개 내용을 사람이 컨펌했는지 여부
  isTrTmAvailable: boolean; // 매출 시간 존재 여부
  memo: string; // 비고
  outAmt: number;
  storeId: string; // 거래처 ID
  storeName: string; // 거래처명
  trBr: string; // 거래점명
  trDetail: string | null; // 거래내용상세
  trDtTm: string; // 거래일시
  trNm: string; // 적요
  trRnd: number | null; // 납입회차
  trTp: string; // 거래 구분명
  userMemo: string | null; // 사용자 메모
  wlbn: string | null; // 월분
  newzenSlipKeyNoList?: string[] | null; // 세무사랑 전송 키 목록
}

export interface BankStatementWithAdditionalData extends BankStatement {
  accountName: string | null; // 계정과목명
  accountCodeName: string | null; // 계정과목명 (계정코드와 함께 사용)
  amount: number; // 표기 금액 (입금 or 출금)
  dealType: "입금" | "출금"; // 입출금 여부
  accNoSplit: string; // 계좌번호를 '-'로 나눈 값
}
